const ONE_ANSWER = 'ONE'
const MULTIPLE_ANSWERS = 'MULTIPLE'
const TEXT_ANSWER = 'TEXT'

export default {
  ONE_ANSWER: ONE_ANSWER,
  MULTIPLE_ANSWERS: MULTIPLE_ANSWERS,
  TEXT_ANSWER: TEXT_ANSWER
}
